module.exports = "<p>section-eight-award works!</p>\n"